import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { registerSW } from 'virtual:pwa-register';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/index.css';
import './i18n';

// Register Service Worker
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New content available. Reload?')) {
      updateSW(true);
    }
  },
});

// Capture install prompt globally
window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  console.log('Install prompt captured globally');
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Premium Real-Time Data Matrix
      staleTime: 10 * 1000, // Consider data stale after 10 seconds
      retry: 1,
      refetchOnWindowFocus: true, // Instantly refresh data when clicking back to the tab
      refetchOnReconnect: true, // Instantly refresh when network reconnects
      refetchInterval: 30 * 1000, // Background heartbeat: Sync data every 30 seconds
    },
  },
});

import ErrorBoundary from './components/common/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
            <Toaster
              position="top-right"
              richColors
              closeButton
            />
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

